/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-nested-ternary */
import React from 'react'
import { checkPermission as cp } from '../utils/auth'
import { useModal } from '../hooks/modal'
import { useDeleteRequest } from '../hooks/request'
import { NOTE_ITEM_DETAIL } from '../urls'
import { useMessage } from '../hooks/message'
import Loader from './common/Loader'
import NoteItemUpdate from './NoteItemUpdate'
import { getDateTime } from '../utils/date'


export default function NoteItemItem({ item, onUpdate, onDelete, index }) {
    const deleteRoom = useDeleteRequest()
    const [showMessage] = useMessage()

    async function deleteColumn() {
        if (global.confirm('Вы действительно хотите удалить?')) {
            const { error } = await deleteRoom.request({ url: NOTE_ITEM_DETAIL.replace('{id}', item.id) })

            if (error) {
                showMessage(error.data.detail, 'is-danger')
                return
            }
            onDelete()
        }
    }

    const [showUpdateModal, hideUpdateModal] = useModal(
        <NoteItemUpdate item={item} onSuccess={async () => {
            await onUpdate()
            hideUpdateModal()
        }} onCancel={() => {
            hideUpdateModal()
        }} />,
    )
    return (
        <tr>
            <td>
                {index + 1}
            </td>

            <td>
                {item.employee.name}
            </td>
            <td>
                <span className="is-uppercase tag is-light is-link">{item.note.mark}</span>
            </td>
            <td>
                <span className="tag is-light is-danger">{item.note.price} сўм</span>
            </td>
            <td>{item?.comment}</td>
            <td>
                {getDateTime(item.createdAt)}
            </td>

            <td>
                <div className="is-pulled-right is-flex">
                    {cp('academy.delete_room') ? (
                        !deleteRoom.loading ? (
                            <i onClick={deleteColumn} className="icon pointer ion-md-trash" />
                        ) : <Loader className="icon" />
                    ) : null}

                    {cp('academy.change_room') ? (
                        <i onClick={showUpdateModal} className="icon pointer ion-md-create" />
                    ) : null}

                </div>
            </td>
        </tr>
    )
}
